// Single source of truth for the Lyric API base URL.
//
// Resolution order:
//   1. Runtime config injected by the Lyric backend into index.html as
//      window.__LYRIC_ENV__ (values come from the process env / lyric-secrets
//      at request time). This is what lets ONE static production bundle serve
//      any environment without rebaking build-time env vars.
//   2. Build-time env (process.env.REACT_APP_API_URL) for per-environment
//      static builds or the local dev server (`npm start`).
//   3. Same-origin: in production the SPA is served by the very backend that
//      exposes /api and /apps, so the current origin IS the API base.
//   4. Local dev fallback.
//
// Always returns a value with no trailing slash so callers can safely do
// `${getApiBase()}/api/...`.
export function getApiBase() {
  const runtime =
    typeof window !== 'undefined' &&
    window.__LYRIC_ENV__ &&
    window.__LYRIC_ENV__.REACT_APP_API_URL;
  if (runtime) return String(runtime).replace(/\/+$/, '');

  if (process.env.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname;
    if (host && host !== 'localhost' && host !== '127.0.0.1') {
      return `${window.location.protocol}//${window.location.host}`;
    }
  }

  return 'http://localhost:3001';
}

export default getApiBase;
